/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2019 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {

  $(document).ready(function () {

    $('.hours-dropdown__link').on('click', function(event) {
      if ($(this).attr('aria-expanded') == 'false') {
        $(this).attr('aria-expanded', 'true');
      } else {
        $(this).attr('aria-expanded', 'false');
      }
      event.stopPropagation();
    });

    $(window).on('click', function(event) {
      // If user clicks inside the hours dropdown, do nothing
      if($(event.target).closest('.hours-dropdown__menu').length === 0) {
        // Hide hours when users clicks outside of dropdown
        $('.hours-dropdown__link').attr('aria-expanded', 'false');
      }
    });

  });

})(jQuery);
